import * as _ from 'lodash';
import * as utility from '../misc/utility';
import { BaseObject } from './BaseObject';

/**
 * @typedef { import('../server/ResponseContext').ResponseContext } ResponseContext
*/

export const lostIncomeBenefitsMode = Object.freeze({
    disabled: 0,
    byrequest: 1,
    always: 2,
});

function subSettingsToJSON(x) {
    let ret = _.clone(x);
    if (ret.WageType) {
        ret.WageTypeId = ret.WageType.Id;
        delete ret.WageType;
    }
    return ret;
}

export class PolitikerSettings extends BaseObject {
    constructor(src) {
        super();

        this.Vat = {};
        this.LostIncomeAmount = {};
        this.LostIncomeNumberUnit = {};
        this.LostIncomeNumber = {};
        this.RetirementBenefits = {};
        this.VacationBenefits = {};
        this.Travel = {};
        this.Parking = {};
        this.Congestion = {};
        this.PublicTransport = {};
        this.TravelTime = {};
        this.Expenses = {};
        this.Adjuster = {};

        if (src) {
            _.extend(this, src);
            this.StartDate = utility.parseDate(src.StartDate);
        }
    }

    /**
     * 
     * @param {ResponseContext} ctx
     */
    resolve(ctx) {
        this.Vat.WageType = ctx.getWageType(this.Vat.WageTypeId);
        this.LostIncomeAmount.WageType = ctx.getWageType(this.LostIncomeAmount.WageTypeId);
        this.LostIncomeNumberUnit.WageType = ctx.getWageType(this.LostIncomeNumberUnit.WageTypeId);
        this.LostIncomeNumber.WageType = ctx.getWageType(this.LostIncomeNumber.WageTypeId);
        this.RetirementBenefits.WageType = ctx.getWageType(this.RetirementBenefits.WageTypeId);
        this.VacationBenefits.WageType = ctx.getWageType(this.VacationBenefits.WageTypeId);
        this.Travel.WageType = ctx.getWageType(this.Travel.WageTypeId);
        this.Parking.WageType = ctx.getWageType(this.Parking.WageTypeId);
        this.Congestion.WageType = ctx.getWageType(this.Congestion.WageTypeId);
        this.PublicTransport.WageType = ctx.getWageType(this.PublicTransport.WageTypeId);
        this.TravelTime.WageType = ctx.getWageType(this.TravelTime.WageTypeId);
        this.Expenses.WageType = ctx.getWageType(this.Expenses.WageTypeId);
        this.Adjuster.WageType = ctx.getWageType(this.Adjuster.WageTypeId);
    }

    toJSON() {
        var ret = super.toJSON();
        ret.Vat = subSettingsToJSON(ret.Vat);
        ret.LostIncomeAmount = subSettingsToJSON(ret.LostIncomeAmount);
        ret.LostIncomeNumberUnit = subSettingsToJSON(ret.LostIncomeNumberUnit);
        ret.LostIncomeNumber = subSettingsToJSON(ret.LostIncomeNumber);
        ret.RetirementBenefits = subSettingsToJSON(ret.RetirementBenefits);
        ret.VacationBenefits = subSettingsToJSON(ret.VacationBenefits);
        ret.Travel = subSettingsToJSON(ret.Travel);
        ret.Parking = subSettingsToJSON(ret.Parking);
        ret.Congestion = subSettingsToJSON(ret.Congestion);
        ret.PublicTransport = subSettingsToJSON(ret.PublicTransport);
        ret.TravelTime = subSettingsToJSON(ret.TravelTime);
        ret.Expenses = subSettingsToJSON(ret.Expenses);
        ret.Adjuster = subSettingsToJSON(ret.Adjuster);
        return ret;
    }

    clone() {
        let ret = new PolitikerSettings();
        _.assign(ret, this);
        ret.Vat = _.clone(ret.Vat);
        ret.LostIncomeAmount = _.clone(ret.LostIncomeAmount);
        ret.LostIncomeNumberUnit = _.clone(ret.LostIncomeNumberUnit);
        ret.LostIncomeNumber = _.clone(ret.LostIncomeNumber);
        ret.RetirementBenefits = _.clone(ret.RetirementBenefits);
        ret.VacationBenefits = _.clone(ret.VacationBenefits);
        ret.Travel = _.clone(ret.Travel);
        ret.Parking = _.clone(ret.Parking);
        ret.Congestion = _.clone(ret.Congestion);
        ret.PublicTransport = _.clone(ret.PublicTransport);
        ret.TravelTime = _.clone(ret.TravelTime);
        ret.Expenses = _.clone(ret.Expenses);
        ret.Adjuster = _.clone(ret.Adjuster);
        return ret;
    }
}